// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicies_container__MJfle","section":"PrivacyPolicies_section__8adLa","cross":"PrivacyPolicies_cross__hye4A"};